export interface UserTimingMetric {
    start: string
    finish: string
    name: string
}

enum UserTimingMetricName {
    OpenDialog = "OpenDialog",
    OpenClient = "OpenClient",
    OpenFastRepliesSidebar = "OpenFastRepliesSidebar",
    OpenKnowledgeBaseSidebar = "OpenKnowledgeBaseSidebar",
    SendMessageByOperator = "SendMessageByOperator",
    FinishDialog = "FinishDialog"
}

type UserTimingMetricsList = {
    [key in UserTimingMetricName]: UserTimingMetric
}

const buildUserTimingMetric = (name: string): UserTimingMetric => ({
    start: `${name}:start` as const,
    finish: `${name}:finish` as const,
    name
})
export const userTimingMetricsList: UserTimingMetricsList = {
    OpenDialog: buildUserTimingMetric(UserTimingMetricName.OpenDialog),
    FinishDialog: buildUserTimingMetric(UserTimingMetricName.FinishDialog),
    OpenClient: buildUserTimingMetric(UserTimingMetricName.OpenClient),
    OpenFastRepliesSidebar: buildUserTimingMetric(UserTimingMetricName.OpenFastRepliesSidebar),
    OpenKnowledgeBaseSidebar: buildUserTimingMetric(UserTimingMetricName.OpenKnowledgeBaseSidebar),
    SendMessageByOperator: buildUserTimingMetric(UserTimingMetricName.SendMessageByOperator)
}

export default userTimingMetricsList
